import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Get Info for insurance holder (tomador)
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinsuranceholder
*/
export const requestInsuranceHolder = payload => {
	return httpClient({
		method: 'GET',
		url: 'insurance/holder',
		isCancellable: true
	})
}

/** Get insurance domains lists
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinsurancelovsdomain
*/
export const requestInsuranceDomainsList = payload => {
	return httpClient({
		method: 'GET',
		url: `insurance/lovs/${payload.domain}`,
        params: payload.params,
		isCancellable: true
	})
}

/** Submit Quotation
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetinsurance%7BproductCode%7Dquotationsubmit
*/
export const submitQuotation = payload => {
	return httpClient({
		method: 'POST',
		url: `insurance/${payload.productCode}/quotation/submit`,
        data: payload.data
	})
}

/** Accept quotation
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_internetinsurance%7BinsuranceId%7Dquotationaccept
*/
export const acceptQuotation = payload => {
	return httpClient({
		method: 'PUT',
		url: `insurance/${payload}/quotation/accept`
	})
}

/** Submit Proposal (this api, will also create policy in the mdw background)
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetinsurance%7BinsuranceId%7Dproposalsubmit
@payload - also send product in your payload for a diferent mock between diferente products [TRAVEL, AUTO]
*/
export const submitProposal = payload => {
	return httpClient({
		method: 'POST',
		url: `insurance/${payload.insuranceId}/proposal/submit`,
        data: payload.data,
		useChallengeMock: true,
		operationTypeId: '501003', /* for mocks handling of tokens */
		extraMockIdentifier: payload.product /* for mocks handling of tokens */
	})
}

/** Get Policies Status List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinsurancelovspolicystatus
*/
export const getPoliciesStatusList = payload => {
	return httpClient({
		method: 'GET',
		url: 'insurance/policies/lovs/policy/status',
		isCancellable: true
	})
}

/** Get Policies List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinsurancepolicies
*/
export const getPoliciesList = payload => {
	return httpClient({
		method: 'GET',
		url: 'insurance/policies',
		data: payload
	})
}

/** Get Policy Details
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinsurance%7BinsuranceId%7Dpolicydetails
*/
export const getPolicyDetails = payload => {
	return httpClient({
		method: 'GET',
		url: `insurance/${payload}/policy/details`,
		isCancellable: true
	})
}

/** Get Policy Receipts
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinsurance%7BinsuranceId%7Dreceipts
*/
export const getPolicyReceiptsList = payload => {
	return httpClient({
		method: 'GET',
		url: `insurance/${payload}/receipts`,
		isCancellable: true
	})
}

/** Get Policy Receipt Details
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinsurance%7BinsuranceId%7Dreceipt%7BreceiptId%7Ddetails
*/
export const getPolicyReceiptDetail = payload => {
	return httpClient({
		method: 'GET',
		url: `insurance/${payload.insuranceId}/receipt/${payload.receiptId}/details`,
		isCancellable: true
	})
}

/** Get Policy Receipt Documents List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinsurance%7BinsuranceId%7Dreceipt%7BreceiptId%7Ddocuments
*/
export const getPolicyReceiptDocumentsList = payload => {
	return httpClient({
		method: 'GET',
		url: `insurance/${payload.insuranceId}/receipt/${payload.receiptId}/documents`,
		isCancellable: true
	})
}

/** Creates the url to download an insurance PDF
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinsurance%7BinsuranceId%7Dpdf
*/
export const createDownloadInsuranceUrl = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `insurance/${payload}/pdf/`
	})
}

/** Creates the url to download a policy
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinsurance%7BinsuranceId%7Dpolicydocument
*/
export const createDownloadPolicyUrl = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `insurance/${payload}/policy/document/`
	})
}

/** Creates the url to download a policy document
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinsurance%7BinsuranceId%7Dreceipt%7BreceiptId%7Ddocument%7BdocType%7D
*/
export const createDownloadPolicyDocumentUrl = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `insurance/${payload.insuranceId}/receipt/${payload.receiptId}/document/${payload.docType}`
	})
}
